import { z } from 'zod';

/**
 * Enum catalog — the single source of truth mirroring the 5 native Postgres
 * enums declared in drizzle/schema.ts (data-model.md §0 "Enum catalog").
 *
 * Each Zod enum lists the SAME values, in the SAME order, as its `pgEnum`. The
 * API validates against these; the web derives form option lists from them.
 * `MasterListShareRole` is intentionally re-exported from `common.ts` (it is the
 * api-contract §6 canonical name) and is the same two-role model as `ShareRole`.
 */

/** PG `share_role` — master_list_shares.role + trip_collaborators.role. */
export const ShareRole = z.enum(['viewer', 'editor']);
export type ShareRole = z.infer<typeof ShareRole>;

/** PG `trip_status` — trips.status. */
export const TripStatus = z.enum(['active', 'closed']);
export type TripStatus = z.infer<typeof TripStatus>;

/** PG `trip_item_status` — trip_items.status (PRD §10). */
export const TripItemStatus = z.enum(['todo', 'doing', 'done']);
export type TripItemStatus = z.infer<typeof TripItemStatus>;

/** PG `lesson_type` — lessons.type (PRD §15). */
export const LessonType = z.enum(['forgot', 'didnt_need', 'note']);
export type LessonType = z.infer<typeof LessonType>;

/** PG `lesson_status` — lessons.status. */
export const LessonStatus = z.enum(['open', 'applied', 'dismissed']);
export type LessonStatus = z.infer<typeof LessonStatus>;

/**
 * Reserved built-in label strings (data-model.md §11, PRD §9). `to buy` is the
 * Shopping label — a normal `trip_item_labels` row whose only special behavior
 * is the "bought" action. Defined ONCE here so API and web agree (T19/T20/T24).
 */
export const BUILTIN_LABELS = {
  TO_BUY: 'to buy',
} as const;
